import React from 'react';
import { getCountryName } from '../../../../utils/countryNamesClient';
import SecuritySection from './ui/SecuritySection';
import SecuritySeverityBadge from './ui/SecuritySeverityBadge';
import SecurityEmptyState from './ui/SecurityEmptyState';
import { IconGlobe } from '../../ui/adminIcons';
import { formatMinutesAgo, getEventTypeLabel } from '../securityUtils';

const SEVERITY_LEGEND = ['critical', 'high', 'medium', 'low'];

export default function SecurityGeoThreatsPanel({ threatAnalysis }) {
  const countries = threatAnalysis?.attackMap?.countriesArray || [];
  const recentAttacks = threatAnalysis?.attackMap?.recentAttacks || [];

  return (
    <SecuritySection title="Geographic activity (24h)" icon={<IconGlobe />}>
      <div className="vx-sec-geo-panel">
        <p className="vx-sec-geo-note">
          Country counts are security events from MongoDB in the last 24 hours, using geoip-lite at log time.
          Private IPs are excluded. Recent activity below shows the last hour only.
        </p>

        <div className="vx-sec-geo-summary">
          {countries.length > 0 ? (
            <span className="vx-sec-geo-summary-text">
              Activity from {countries.length} {countries.length === 1 ? 'country' : 'countries'}
            </span>
          ) : (
            <span className="vx-sec-geo-summary-text">No geographic activity in the last 24 hours</span>
          )}
          <div className="vx-sec-legend" aria-hidden="true">
            {SEVERITY_LEGEND.map((level) => (
              <span key={level} className="vx-sec-legend-item">
                <span className={`vx-sec-legend-dot vx-sec-legend-dot--${level}`} />
                {level.charAt(0).toUpperCase() + level.slice(1)}
              </span>
            ))}
          </div>
        </div>

        {countries.length > 0 ? (
          <div className="vx-sec-table-wrap admin-table">
            <table className="vx-sec-table">
              <thead>
                <tr>
                  <th>Country</th>
                  <th>Events</th>
                  <th>Severity</th>
                  <th>Last seen</th>
                </tr>
              </thead>
              <tbody>
                {countries.map((country) => (
                  <tr key={country.name}>
                    <td>{getCountryName(country.name)}</td>
                    <td>{country.attacks}</td>
                    <td>
                      <SecuritySeverityBadge severity={country.severity} />
                    </td>
                    <td className="vx-sec-muted">
                      {country.lastAttack ? formatMinutesAgo(country.lastAttack) : '—'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <SecurityEmptyState title="No country-level activity recorded" />
        )}

        <div className="vx-sec-recent-feed">
          <h3 className="vx-sec-subtitle">Recent activity (last hour)</h3>
          {recentAttacks.length > 0 ? (
            <ul className="vx-sec-feed-list">
              {recentAttacks.slice(0, 5).map((attack, index) => (
                <li key={`${attack.timestamp}-${attack.ip}-${index}`} className="vx-sec-feed-item">
                  <span className="vx-sec-feed-main">
                    {getCountryName(attack.country) || 'Unknown'} — {getEventTypeLabel(attack.eventType)}
                  </span>
                  <span className="vx-sec-feed-meta">
                    <SecuritySeverityBadge severity={attack.severity} />
                    <span>{formatMinutesAgo(attack.timestamp)}</span>
                  </span>
                </li>
              ))}
            </ul>
          ) : (
            <SecurityEmptyState title="No recent activity in the last hour" />
          )}
        </div>
      </div>
    </SecuritySection>
  );
}
